import React from "react";
import { useRouteQuery } from "../hooks/router.hooks";
import { usePropertyShare } from "../hooks/property.hooks";
import { ErrorCentered } from "../components/loaders/ErrorCentered";
import { PropertyShare } from "./PropertyShare";
import { LoaderCentered } from "../components/loaders/LoaderCentered";
import { PropertyWithGallery } from "./property/PropertyWithGallery";

interface PropertyShareLinkProps {
  isQuickValuation?: boolean;
}

export const PropertyShareLink: React.FC<PropertyShareLinkProps> = ({
  isQuickValuation,
}) => {
  const query = useRouteQuery();

  const token = query.get("token");

  const { data, isError, isLoading } = usePropertyShare(token ?? "");

  if (isError) {
    return <ErrorCentered />;
  }

  if (isLoading) {
    return <LoaderCentered />;
  }

  if (!data) {
    return null;
  }

  return (
    <PropertyWithGallery property={data.property}>
      <PropertyShare data={data} isQuickValuation={isQuickValuation} />
    </PropertyWithGallery>
  );
};
